exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qrCodeContents{padding:30px 60px}.qrCodeContents ul li{position:relative;margin-bottom:50px}.qrCodeContents ul li:last-child{margin-bottom:0px}.qrCodeContents h4{color:#768291;font-size:20px;font-weight:600}.qrCodeContents h4 span{background-color:#265390;color:#ffffff;height:30px;width:30px;border-radius:50%;position:absolute;top:-3px;left:-50px;font-size:18px;text-align:center;line-height:28px}@media (max-width: 1366px){.qrCodeContents h4{font-size:18px;line-height:22px}.qrCodeContents ul li{margin-bottom:30px}}@media (max-width: 767px){.qrCodeContents{padding:10px 30px}}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/things/onboard/qr-code.scss
// module id = 1389
// module chunks = 0